<template>
    <div class="doubts-table-page weeduc-admin-page text-start p-0">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    :title="$t('admin.doubts.title')"
                    :subtitle="$t('admin.doubts.subtitleManage')"
                    :hasMargin="false"
                />
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel">
                <div class="weeduc-admin-page__toolbar">
                    <v-row align="end" dense>
                        <v-col cols="12" sm="8" md="6" lg="8">
                            <v-text-field
                                v-model="searchText"
                                :label="$t('common.search')"
                                :placeholder="$t('admin.doubts.searchPlaceholder')"
                                class="inputd weeduc-admin-v-field"
                                variant="outlined"
                                density="compact"
                                hide-details
                                clearable
                                append-inner-icon="mdi-magnify"
                                @update:model-value="onSearch"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4">
                            <v-select
                                v-model="statusFilter"
                                :items="statusFilterOptions"
                                item-title="text"
                                item-value="value"
                                :label="$t('common.status')"
                                variant="outlined"
                                class="inputd weeduc-admin-v-field"
                                :menu-props="adminSelectMenuProps"
                                @update:modelValue="filtrarDoubts"
                                density="compact"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                </div>

                <div class="weeduc-admin-page__table-section">
                    <v-table class="custom-table doubts-admin-table" density="compact">
                        <thead>
                            <tr>
                                <th class="doubts-table__title-column">{{ $t('admin.doubts.titleFallback') }}</th>
                                <th class="doubts-table__student-column">{{ $t('admin.doubts.studentColumn') }}</th>
                                <th class="text-center">{{ $t('common.status') }}</th>
                                <th class="text-center">{{ $t('admin.forum.see') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doubt in paginatedDoubts" :key="doubt.id">
                                
                                <td class="doubts-table__title-column">
                                    {{ doubt.title }}
                                </td>
                                <td class="doubts-table__student-column">
                                    {{ doubt.nameUser.charAt(0).toUpperCase() + doubt.nameUser.slice(1) }}
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        density="compact"
                                        :color="getStatusColor(doubt.status)"
                                    >
                                        {{ getStatusText(doubt.status) }}
                                    </v-chip>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="heading"
                                        @click="viewDoubt(doubt.id, doubt)"
                                        icon
                                        :title="$t('admin.doubts.seeDetails')"
                                        variant="text"
                                    >
                                        <Icon name="eye" size="20" />
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>

                <v-responsive class="weeduc-admin-page__pagination">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="5"
                        :disabled="!hasReady"
                        @update:model-value="onPageChange"
                    ></v-pagination>
                </v-responsive>

                <Loader v-if="!hasReady" />
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader/loader.vue';
import TitlePage from '@/components/Weflix/titlePage.vue';
import ApiInquiry from '@/utils/inquiry';
import { debounce } from 'lodash';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';

export default {
    components: {
        Loader,
        TitlePage,
    },
    data() {
        return {
            doubtsData: [],
            searchText: '',
            currentPage: 1,
            itemsPerPage: 10,
            hasReady: false,
            statusFilter: 'todos',
        };
    },
    computed: {
        ...mapState(['token', 'numberIntensTable', 'dark']),

        statusFilterOptions() {
            return [
                { text: this.$t('common.all'), value: 'todos' },
                { text: this.$t('admin.doubts.answered'), value: '1' },
                { text: this.$t('admin.doubts.statusNotAnswered'), value: '0' },
            ];
        },

        adminSelectMenuProps() {
            return this.dark
                ? { contentClass: 'weeduc-admin-select-menu-dark' }
                : {};
        },

        paginatedDoubts() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.filteredDoubts.slice(startIndex, endIndex);
        },
        
        totalPages() {
            return Math.ceil(this.filteredDoubts.length / this.itemsPerPage);
        },
        
        filteredDoubts() {
            let filtered = this.doubtsData;

            if (this.searchText && this.searchText.trim() !== '') {
                filtered = filtered.filter((doubt) =>
                    doubt.title.toLowerCase().includes(this.searchText.toLowerCase()) ||
                    doubt.nameUser.toLowerCase().includes(this.searchText.toLowerCase())
                );
            }
            
            if (this.statusFilter !== 'todos') {
                filtered = filtered.filter((doubt) => {
                    return doubt.status === parseInt(this.statusFilter);
                });
            }

            return filtered;
        }
    },
    created() {
        this.getListInquiry();
    },
    methods: {
        ...mapActions(['storeDoubt']),
        
        getStatusColor(status) {
            switch (status) {
                case 1: return 'success';
                case 0: return 'warning';
                case 9: return 'danger';
                default: return 'grey';
            }
        },
        
        getStatusText(status) {
            switch (status) {
                case 1: return this.$t('admin.doubts.answered');
                case 0: return this.$t('admin.doubts.statusNotAnswered');
                case 9: return this.$t('admin.doubts.statusDeleted');
                default: return this.$t('common.unknown');
            }
        },
        
        filtrarDoubts() {
            this.currentPage = 1;
        },
        
        viewDoubt(id, doubt) {
            this.storeDoubt({ doubt: doubt });
            this.$router.push('duvida/' + id);
        },
        
        async getListInquiry() {
            try {
                this.hasReady = false;
                const response = await ApiInquiry.getDataInquiry(this.token);
                this.doubtsData = response.map(doubt => {
                    const { ...rest } = doubt;
                    return rest;
                });
                this.hasReady = true;
            } catch (error) {
                toast.error('Erro ao carregar as dúvidas. Por favor, tente novamente.');
                console.error('Erro ao carregar as dúvidas', error);
            }
        },
        
        getIndexById(id) {
            const index = this.doubtsData.findIndex(doubt => doubt.id === id);
            return index + 1; 
        },
        
        onSearch: debounce(function () {
            this.currentPage = 1;
        }, 300),
        
        onPageChange() {
        }
    }
};
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import '@/css/weeduc/admin/faq.css';

.doubts-table__title-column {
    width: 42%;
}

.doubts-table__student-column {
    width: 28%;
}

.custom-table {
    margin-bottom: 1rem;
}

.doubts-admin-table :deep(thead th) {
    font-weight: 600;
    color: #4a5568;
    font-size: 0.8125rem;
    letter-spacing: 0.02em;
}

.doubts-admin-table :deep(tbody td) {
    vertical-align: middle;
}

.doubts-admin-table :deep(tbody tr:hover) {
    background-color: rgba(37, 8, 145, 0.045) !important;
}

.dashboard.dark .doubts-admin-table :deep(thead th) {
    color: #c5cad6;
}

.dashboard.dark .doubts-admin-table :deep(tbody tr:hover) {
    background-color: rgba(255, 255, 255, 0.06) !important;
}
</style>